import { message } from 'antd';
import { dateFormatMap, dateTimeFormatMap } from './config';
import { FormatMoney } from '@/utils';
import { formatLocalTime } from '@/utils/timeConversionTool';

export function showErrorMessage(code: string, t: any) {
    // 积分不足
    if (code === '2418') {
        message.error(t('no_enough_points'));
        return;
    }

    // 前端页面长时间不刷新，导致兑换规则落后后端版本
    if (code === '2422') {
        message.error(t('stay_too_long'));
        return;
    }

    // 兑换次数超出上限
    if (code === '2423') {
        message.error(t('exceeded_counts'));
        return;
    }

    // 前端页面长时间不刷新，导致优惠券规则超过截止时间
    if (code === '2424') {
        message.error(t('stay_too_long'));
        return;
    }

    // 库存不足
    if (code === '2426') {
        message.error(t('no_stock_tip'));
        return;
    }

    // 库存不足
    if (code === '2429') {
        message.error(t('no_stock_tip'));
        return;
    }

    // 活动未开始
    if (code === '2430') {
        message.error(t('active_is_unstart'));
        return;
    }

    // 活动已结束
    if (code === '2431') {
        message.error(t('active_is_ended'));
        return;
    }

    // 活动被禁用
    if (code === '2432') {
        message.error(t('active_is_ended'));
        return;
    }

    // 超出兑换次数
    if (code === '2433') {
        message.error(t('over_max_count'));
        return;
    }

    // 抽中券，但是券过期的情况
    if (code === '2434') {
        message.error(t('active_is_ended'));
        return;
    }

    message.error(t('stay_too_long'));
}

// 给coupon添加Notes
export const injectNotes = (coupon: any[], t: any, locale: string, timezoneList: any) => {
    return coupon?.map((coupon: any) => {
        if (coupon.rules !== null && typeof coupon.rules === 'object') {
            coupon = {
                ...coupon,
                ...coupon.rules,
            };
        }
        const noteList: string[] = [t('site_rules'), t('order_rule')];

        // 不找零
        if (coupon?.prerequisite !== 'PRICES' && coupon?.discountType === 'fixed_amount') {
            noteList.push(t('purchas_rule'));
        }
        if (coupon?.prerequisite === 'PRICES' && coupon?.discountType === 'fixed_amount') {
            const couponPrice = parseInt(coupon?.amount);
            const priceRange = parseInt(coupon.prerequisiteRange);
            if (priceRange < couponPrice) {
                noteList.push(t('purchas_rule'));
            }
        }
        if (coupon?.goodId) noteList.push(t('product_rules', { product: coupon?.goodTitle || '' }));

        // 最低金额
        if (coupon?.prerequisite === 'PRICES') {
            const price = parseInt(coupon.prerequisiteRange);
            const currencySymbol = coupon?.currencySymbol || '';
            const prerequisiteRange = t('minimum_price', { price: currencySymbol + FormatMoney(price) });
            noteList.push(prerequisiteRange);
        }

        // 最低数量
        if (coupon?.prerequisite === 'QUANTITY') {
            const num = parseInt(coupon.prerequisiteRange);
            const prerequisiteRange = t('minimum_num', { num });
            noteList.push(prerequisiteRange);
        }

        // 过期天数
        const limitDay = Math.floor((coupon?.expiredDay || 0) / 60 / 24);

        if (coupon?.expiredFlag && coupon?.expiredType === 'DAY') {
            noteList.push(t('days_rules', { days: limitDay }));
        }
        // 时间 for 福利中心
        if (coupon?.couponId && coupon?.endTime && coupon?.expiredType === 'TIME') {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            const startTime = formatLocalTime(coupon?.startTime, timezoneList, formater);
            const endTime = formatLocalTime(coupon?.endTime, timezoneList, formater);
            noteList.push(t('days_rules2', { data: `${startTime}-${endTime}` }));
        }

        // 时间 for 优惠券
        if (coupon?.coupon && coupon?.endTime) {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            // const startTime = moment(Number(coupon?.startTime)).format(formater);
            // const endTime = moment(Number(coupon?.endTime)).format(formater);
            const startTime = formatLocalTime(coupon?.startTime, timezoneList, formater);
            const endTime = formatLocalTime(coupon?.endTime, timezoneList, formater);
            noteList.push(t('days_rules2', { data: `${startTime}-${endTime}` }));
        }

        // 时间 for 优惠券规则
        if (!(coupon?.coupon || coupon?.couponId) && coupon?.expiredFlag && coupon?.validEndTime && coupon?.expiredType === 'TIME') {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            const startTime = formatLocalTime(coupon?.validStartTime, timezoneList, formater);
            const endTime = formatLocalTime(coupon?.validEndTime, timezoneList, formater);
            noteList.push(t('days_rules2', { data: `${startTime}-${endTime}` }));
        }

        // campaign限时型时间
        if (!coupon?.discountId && coupon?.campaignStartTime && coupon?.campaignEndTime) {
            const formater = dateFormatMap[locale as string] || dateFormatMap['us'];
            const startTime = formatLocalTime(coupon?.campaignStartTime, timezoneList, formater);
            const endTime = formatLocalTime(coupon?.campaignEndTime, timezoneList, formater);
            noteList.push(t('campaign_time_limit_text', { startTime, endTime }));
        }
        // 临时新增规则 只针对这一个优惠券
        if (coupon?.discountId && coupon?.discountId === '1698949120957939713') {
            noteList.push('*단순 개봉 제품');
        }
        if (coupon?.extRuleDesc) {
            noteList.push(coupon?.extRuleDesc);
        }

        return { ...coupon, showMore: false, noteList };
    });
};
